import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DialogModule } from '../dialogs/dialogs.module';
import { TranslateModule } from '@ngx-translate/core';
import { CommonDirectivesModule } from '../directives/common-directives.module';
import { LookupDialogComponent } from './lookup-dialog.component';
import { LookupAutocompleteComponent } from './lookup-autocomplete.component';
import { LookupGridComponent } from './lookup-grid.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { AutocompleteDataFactoryProvider } from './lookup-autocomplete-data';
import { LookupDialogService } from './lookup-dialog.service';
import { LookupDialogApi } from './lookup-dialog.api';
import { CommonComponentsModule } from '../components/common-components.module';
import { LookupInputComponent } from './lookup-input/lookup-input.component';
import { NgxCompleterModule } from '../ngx-completer/ngx-completer.module';

const components = [
  LookupDialogComponent, LookupAutocompleteComponent, LookupGridComponent, LookupInputComponent
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    DialogModule,
    TranslateModule.forChild(),
    CommonDirectivesModule,
    NgxDatatableModule,
    CommonComponentsModule,
    NgxCompleterModule
  ],
  declarations: components,
  providers: [LookupDialogApi, LookupDialogService, AutocompleteDataFactoryProvider],
  entryComponents: [LookupDialogComponent],
  exports: [LookupDialogComponent, LookupInputComponent],
  schemas: []
})
export class LookupDialogModule {
}
